import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGTMPriceHistorySignUpClick = (clickText: string) => {
    const eventData = {
        event: "price_history_button",
        event_action: "click",
        event_label: clickText
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMPriceHistoryAlertClick = (clickText: string) => {
    const eventData = {
        event: "price_history_alert",
        event_action: "click",
        event_label: clickText
    };

    hitGoogleTagManager(eventData);
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGTMPriceHistorySignUpClick = (clickText: string) => {
    const eventData = {
        event: "price_history_button",
        event_action: "click",
        event_label: clickText
    };

    hitGoogleTagManager(eventData);
};

export const hitGTMPriceHistoryAlertClick = (clickText: string) => {
    const eventData = {
        event: "price_history_alert",
        event_action: "click",
        event_label: clickText
    };

    hitGoogleTagManager(eventData);
};
